/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {FC, memo} from 'react';
import EnvironmentIndicator from '@ion/applications/src/env/EnvironmentIndicator';
import DesktopHeaderLogo from './DesktopHeaderLogo';
import DesktopHeaderNotification from './DesktopHeaderNotification';
import styles from './DesktopHeader.module.scss';

export interface DesktopHeaderProps {
  onContactSupportOpen: () => void;
  isAccountRestricted: boolean;
  username?: string;
  onLogout?: () => void;
  onViewIONPrime?: () => void;
  onNotification?: Function;
  onUserProfile?: Function;
  isLoggingOut?: boolean;
  hasPreviewFeature?: boolean;
  isSelected?: boolean;
};

/**
 * @DesktopHeader
 *
 * The Desktop Header component provides the application Header for the iOn Application
 * when view in Desktop Mode.
 */
const DesktopHeader: FC<DesktopHeaderProps> = ({
  onContactSupportOpen,
  isAccountRestricted
}) => {
  return (
    <div className={styles.container}>
      <DesktopHeaderLogo />
      <EnvironmentIndicator />
      <div className={styles.search} style={{flexGrow: 8}}>
        <div style={{width: 421, display: 'inline-flex', marginLeft: 0}} />
      </div>
      <DesktopHeaderNotification onContactSupportOpen={onContactSupportOpen}
        isAccountRestricted={isAccountRestricted} />
    </div>
  );
};

export default memo(DesktopHeader);
